import { useEffect } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import {
  ExternalLink,
  HelpCircle,
  LayoutDashboard,
  LogOut,
  Mail,
  Megaphone,
  Newspaper,
  Package,
  Settings,
  Wrench,
} from "lucide-react";
import { useAdminAuth } from "@/admin/AuthContext";

const MENU = [
  { to: "/admin", icon: LayoutDashboard, label: "Genel Bakış", end: true },
  { to: "/admin/content/packages", icon: Package, label: "Paketler" },
  { to: "/admin/content/services", icon: Wrench, label: "Hizmetler" },
  { to: "/admin/content/campaigns", icon: Megaphone, label: "Kampanyalar" },
  { to: "/admin/content/faqs", icon: HelpCircle, label: "SSS" },
  { to: "/admin/content/posts", icon: Newspaper, label: "Blog" },
  { to: "/admin/messages", icon: Mail, label: "Mesajlar" },
  { to: "/admin/settings", icon: Settings, label: "Site Ayarları" },
];

export default function AdminLayout() {
  const { user, logout } = useAdminAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user === false) navigate("/admin/login");
  }, [user, navigate]);

  if (user === null) {
    return <div className="flex min-h-screen items-center justify-center bg-zinc-950 text-zinc-400">Yükleniyor...</div>;
  }
  if (user === false) return null;

  const linkCls = ({ isActive }) =>
    `flex items-center gap-3 rounded-lg px-3.5 py-2.5 text-sm font-medium transition-colors duration-150 ${
      isActive ? "bg-[#0D9488] text-white" : "text-zinc-400 hover:bg-zinc-800 hover:text-white"
    }`;

  return (
    <div className="flex min-h-screen bg-zinc-100" dir="ltr" data-testid="admin-layout">
      <aside className="fixed inset-y-0 start-0 z-40 flex w-64 flex-col bg-[#062B2B] p-4">
        <div className="flex items-center gap-2 px-2 py-3">
          <img src="/cagrilogo.png" alt="ÇağrıNET" className="h-7 w-auto brightness-0 invert" />
          <span className="ms-1 rounded bg-zinc-800 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wider text-zinc-400">
            Admin
          </span>
        </div>

        <nav className="mt-6 flex-1 space-y-1" data-testid="admin-sidebar">
          {MENU.map((item) => (
            <NavLink key={item.to} to={item.to} end={item.end} className={linkCls} data-testid={`admin-nav-${item.to.split("/").pop()}`}>
              <item.icon className="h-4.5 w-4.5" size={18} />
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="space-y-1 border-t border-zinc-800 pt-4">
          <a
            href="/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 rounded-lg px-3.5 py-2.5 text-sm font-medium text-zinc-400 transition-colors hover:bg-zinc-800 hover:text-white"
          >
            <ExternalLink size={18} />
            Siteyi Görüntüle
          </a>
          <button
            data-testid="admin-logout-button"
            onClick={async () => {
              await logout();
              navigate("/admin/login");
            }}
            className="flex w-full items-center gap-3 rounded-lg px-3.5 py-2.5 text-sm font-medium text-zinc-400 transition-colors hover:bg-red-500/10 hover:text-red-400"
          >
            <LogOut size={18} />
            Çıkış Yap
          </button>
        </div>
      </aside>

      <main className="ms-64 flex-1 p-8">
        <Outlet />
      </main>
    </div>
  );
}
